import React from "react";
import { useNavigate } from "react-router-dom";
import { FaBookOpen, FaAward, FaUserGraduate } from "react-icons/fa";
import "../css/KirnavaliCrestest.css";

// Import your background banner and section image (adjust paths as needed)
import kirnavaliBg from "../../images/Banner3.png";
import kirnavaliMainImg from "../../images/kirnavali-logo.png";

function KirnavaliCrestest() {
    const navigate = useNavigate();

    return (
        <section className="kirnavali-section" style={{ backgroundImage: `url(${kirnavaliBg})` }}>
            <div className="container kirnavali-container-box">
                <div className="row align-items-center g-5">

                    {/* Left Column: Full Width Image */}
                    <div className="col-lg-6">
                        <div className="kirnavali-image-wrapper">
                            <img
                                src={kirnavaliMainImg}
                                alt="Kirnavali Feature"
                                className="kirnavali-main-image img-fluid"
                            />
                        </div>
                    </div>

                    {/* Right Column: Content Pointers & Action Button */}
                    <div className="col-lg-6">
                        <div className="kirnavali-content-wrapper">

                            <span className="kirnavali-mini-tag">ABOUT KIRNAVALI</span>
                            <h2 className="kirnavali-main-heading">Kirnavali – Learn, Compete & Shine</h2>
                            <div className="kirnavali-zigzag-border mb-4"></div>

                            {/* Pointer Items */}
                            <div className="kirnavali-pointers-list">

                                {/* Pointer 1 */}
                                <div className="kirnavali-pointer-item">
                                    <div className="kirnavali-icon-box">
                                        <FaBookOpen />
                                    </div>
                                    <div className="kirnavali-text-block">
                                        <span className="kirnavali-small-tag">National Academic Challenge</span>
                                        <h4>NEP-Aligned Learning</h4>
                                        <p>
                                            A national-level inter-school challenge for Classes 7–10 featuring
                                            three assessment levels covering Mathematics, Science, Social Science,
                                            Aptitude, and General Awareness.
                                        </p>
                                    </div>
                                </div>

                                {/* Pointer 2 */}
                                <div className="kirnavali-pointer-item">
                                    <div className="kirnavali-icon-box">
                                        <FaAward />
                                    </div>
                                    <div className="kirnavali-text-block">
                                        <span className="kirnavali-small-tag">Rewards & Recognition</span>
                                        <h4>Learn & Get Rewarded</h4>
                                        <p>
                                            Qualify at each level to unlock exclusive Crestest learning rewards,
                                            while top performers earn certificates, mementoes, goodies, cash prizes,
                                            and national recognition.
                                        </p>
                                    </div>
                                </div>

                                {/* Pointer 3 */}
                                <div className="kirnavali-pointer-item">
                                    <div className="kirnavali-icon-box">
                                        <FaUserGraduate />
                                    </div>
                                    <div className="kirnavali-text-block">
                                        <span className="kirnavali-small-tag">AI-Powered Assessment</span>
                                        <h4>Instant Performance Insights</h4>
                                        <p>
                                            Every student receives a unique AI-generated question paper with
                                            instant performance reports, detailed analytics, strengths,
                                            improvement areas, and subject-wise insights.
                                        </p>
                                    </div>
                                </div>

                            </div>

                            {/* Action Button */}
                            <div className="mt-4">
                                <button
                                    className="kirnavali-redirect-btn"
                                    onClick={() => navigate('/kirnavali')}
                                >
                                    Explore Kirnavali
                                </button>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default KirnavaliCrestest;